import { Component, OnInit } from '@angular/core'
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { HhgCarrierRateFilingService } from 'src/app/features/hhg-carrier-rate-filing/hhg-carrier-rate-filing.service';
import { AlertService } from 'src/app/services/alert/alert.service';
import { LoadingService } from 'src/app/services/loading/loading.service';
import { IffShipmentDetailsService } from 'src/app/services/iff-shipment-details/iff-shipment-details.service';
import AppConstants, {CarrierApprovalInfo as CAI} from '../../../shared/common-components/AppConstants';


@Component({
    selector: 'app-negative-shipment-report-submission',
    templateUrl: './negative-shipment-report-submission.component.html',
    styleUrls: ['./negative-shipment-report-submission.component.css'],
    standalone: false
})
export class NegativeShipmentReportSubmissionComponent implements OnInit {
  public carrierTSPsList = [];
  public reportingYrQuarterList = [];
  public errorMessage = '';
  public reportSubmissionSuccess = false;
  public reportSubmissionFailure = false;
  public showCarrierTSPs = true;
  public reportMessage = '';
  transTypeList: any[] = [];
  transTypeDomestic: boolean = false;
  transTypeInternational: boolean = false;
  movingTypeList: any[] = [
    { name: 'HHG', value: 'HHG' },
    { name: 'SIT', value: 'SIT' }
  ];
  carrierApprovalInfo: any[];
  carrierId: any;
  negativeShipmentSubmissionGroup: UntypedFormGroup;
  suppressedTransType:boolean[] = [false, false];
  staticTransTypeList = [
    { name: 'General Domestic', value: 'General Domestic' },
    { name: 'Domestic Move Management', value: 'Domestic Movemanagement' },
    { name: 'General International', value: 'General International' },
    { name: 'International Move Management', value: 'International Movemanagement' }
  ];

  constructor(private iffShipmentDetailsService: IffShipmentDetailsService,
    private hhgCarrierRateFilingService: HhgCarrierRateFilingService,
    private fb: UntypedFormBuilder,
    private alertService: AlertService,
    private loader: LoadingService,
    private route: ActivatedRoute) {
    this.loader = loader;

    /**
   *  getting current user from the behavioural subject
   */
    this.loader.show();
    this.hhgCarrierRateFilingService.getCarrierIdByUser().subscribe(carrierId => {
      this.carrierId = carrierId;
      if (this.carrierId !== undefined && this.carrierId !== null) {
        this.loadCarrierApprovalInfo(this.carrierId);
      }
      this.loader.hide();
    }, (error) => {
      this.loader.hide();
      this.alertService.error('Unable to load TSP info values. Please try again later or contact system administrator');
      console.log(error);
    });
  }

  /**
 * @description initializes negativeShipmentSubmission form
 */
  initializeForm() {
    this.negativeShipmentSubmissionGroup = this.fb.group({
      reportingYrQuarterSelect: new UntypedFormControl('', Validators.required),
      carrierTSPSelect: new UntypedFormControl('', Validators.required),
      moveTypeSelect: new UntypedFormControl('', Validators.required),
      transTypeSelect: new UntypedFormControl('', Validators.required)

    });
  }
  ngOnInit() {
    this.initializeForm();
    this.loader.show();

    //This to load list boxes from Negative Shipment Submission Report
    this.iffShipmentDetailsService.getNegativeShipmentSelectOptions()
      .subscribe(selectData => {
        this.carrierTSPsList = selectData.scacTSPsList.sort((a, b) => a.name > b.name ? 1 : -1);
        if (this.carrierTSPsList.length === 0) {
          this.carrierTSPsList = [];
          this.showCarrierTSPs = false;
          this.negativeShipmentSubmissionGroup.get('carrierTSPSelect').setValidators([]);
          this.negativeShipmentSubmissionGroup.get('carrierTSPSelect').updateValueAndValidity();
        } else {
          this.negativeShipmentSubmissionGroup.get('carrierTSPSelect').setValidators([Validators.required]);
          this.negativeShipmentSubmissionGroup.get('carrierTSPSelect').updateValueAndValidity();
          this.showCarrierTSPs = true;
        }
        this.reportingYrQuarterList = selectData.reportingYearQuarterList;
      },
        (error) => {
          this.errorMessage = error;
          console.log('No records found for the negative shipment report list boxes: ' + error);
          this.alertService.error('No records found for the negative shipment report list boxes ');

          this.loader.hide();
        }, () => {
          console.log('Successfully select options list details: ');
          this.loader.hide();
        }
      );
  }


  /**
   * getting carrier approval  info by carrier ID
   */
  loadCarrierApprovalInfo(carrierId) {
    this.transTypeDomestic = false;
    this.transTypeInternational = false;

    this.hhgCarrierRateFilingService.getCarrierApprovalInfo(this.carrierId).subscribe(res => {
      this.carrierApprovalInfo = res;
      if (this.carrierApprovalInfo !== null || this.carrierApprovalInfo !== undefined || this.carrierApprovalInfo.length === 0) {
        for (const carrierApproval of this.carrierApprovalInfo) {
          if (carrierApproval.approvalType === CAI.DOMESTICHHG && carrierApproval.revoked == false) {
            this.transTypeDomestic = true;
          } else if (carrierApproval.approvalType === CAI.INTERNATIONALHHG && carrierApproval.revoked == false) {
            this.transTypeInternational = true;
          }
        }
        this.loadTransType();
      }
    }, (error: any) => {
      this.alertService.error('TSP Approval Info values are unable to load. Please contact administrator or try again after sometime.');
    });
  }

  loadTransType(){
    if(this.transTypeDomestic && this.transTypeInternational){
      this.transTypeList = this.staticTransTypeList;
    }else{
      if(this.transTypeDomestic){
        this.transTypeList = this.staticTransTypeList.filter(x =>  x.value === 'General Domestic' || x.value === 'Domestic Movemanagement');
      }
      if(this.transTypeInternational){
        this.transTypeList = this.staticTransTypeList.filter(x =>  x.value === 'General International' || x.value === 'International Movemanagement');
      }
    }
  }

  changeMoveType(event: any){
    const selectedVal = event.target.value;
    this.loadTransType();
  }

  // This function to submit the Negative Shipment Report form values
  submitReport(formSelect) {
    this.loader.show();
    this.iffShipmentDetailsService.submitNegativeShipmentReport(formSelect).subscribe(reportStatus => {
      if (reportStatus.response == 'SUCCESS') {
        this.reportMessage = 'sucess '
        this.reportSubmissionSuccess = true;
        this.reportSubmissionFailure = false;
      } else if (reportStatus.response == 'DUPLICATE') {
        this.reportSubmissionFailure = true;
        this.reportSubmissionSuccess = false;
      }
    }, (error) => {
      this.alertService.error(error);
      console.log('Error.......... ', error);
      this.loader.hide();
    }, () => {
      this.loader.hide();
    });
  }
}
